import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableCheckBalanceScreen',
  initialState: true,
  reducers: {
    setDisableCheckBalanceScreen(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableCheckBalanceScreen } = slice.actions;

export default slice.reducer;
